import { useEffect, useState, useRef } from "react";

import styles from "./Face3.module.scss";

export default function Face3() {
  const cardRef = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState<number | undefined>(undefined);
  const [letterSpacing, setLetterSpacing] = useState<number | undefined>(
    undefined
  );
  const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);
  const [marginLeft, setMarginLeft] = useState<number | undefined>(undefined);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (cardRef.current) {
        setFontSize(Math.floor(0.035 * cardRef.current.clientWidth));
        setLetterSpacing(0.004 * cardRef.current.clientWidth);
        setLineHeight(0.07 * cardRef.current.clientWidth);
        setMarginLeft(0.57 * cardRef.current.clientWidth);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <div ref={cardRef} className={styles.card}>
      <div
        style={{
          fontSize: `${fontSize}px`,
          letterSpacing: `${letterSpacing}px`,
          lineHeight: `${lineHeight}px`,
          marginLeft: `${marginLeft}px`,
          width: "100%",
        }}
      >
        <p>Darling želi objašnjenje.</p>
        <br />
        <p>Ona ne vjeruje u čarolije.</p>
        <p>Ne čita jezik,</p>
        <p>Ne želi naučiti.</p>
        <p>Darling hoće odgovore,</p>
        <p>Ali nema pitanja.</p>
        <p>Željna je biti uz tebe,</p>
        <p>U pozornosti cvjetat će.</p>
        <p>Ne usuđuj se spomenuti da</p>
        <p>Za svoje godine malo je luda!</p>
        <p>Ali ti mrziš pretvaranje</p>
        <p>I kad su djevojke tinejdžerice.</p>
        <p>Pa, zapravo samo ponekad.</p>
        <p>Kad draga je čeljad.</p>
      </div>
    </div>
  );
}
